import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "nav-bar-search-component",
  class: "red-color pt-1 pb-1 text-white"
}
const _hoisted_2 = { class: "d-flex text-center item fs-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarSearch = _resolveComponent("NavBarSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "clickable item-menu",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedHome && _ctx.clickedHome(...args)))
      }, _toDisplayString(_ctx.welcome), 1),
      _createElementVNode("div", {
        class: "clickable border-start border-2 item-menu",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/videos')))
      }, _toDisplayString(_ctx.videos), 1),
      _createElementVNode("div", {
        class: "clickable border-start border-2 item-menu",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/agency')))
      }, _toDisplayString(_ctx.photosAgency), 1),
      _createElementVNode("div", {
        class: "clickable border-start border-2 item-menu",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/corporate')))
      }, _toDisplayString(_ctx.corporate), 1),
      _createElementVNode("div", {
        class: "clickable border-start border-2 item-menu",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/contact')))
      }, _toDisplayString(_ctx.contact), 1),
      _createVNode(_component_NavBarSearch, {
        class: "flex-grow-1 text-center",
        id: "nav-bar-nav-bar-search"
      })
    ])
  ]))
}